import { FILTER_TYPES } from 'academy-common-lib/constants/TopFilterConstants';
// @ts-ignore Could not find a declaration file for module
import { useSearchParam } from 'academy-common-lib/hooks/searchParamHooks';
import { useSavePlaylist, useSetHiddenForOwner, useUnsavePlaylist } from './myPlaylistsQueries';
import { usePlaylist } from '../savedItems/savedItemsQueries.migrated';
export { useMyPlaylistsParams } from 'academy-common-lib/features/myPlaylists/myPlaylistsHooks';
export const useMyPlaylistsFilters = () => {
  const [[selectedCreatedBy]] = useSearchParam(FILTER_TYPES.CREATED_BY);
  const [[searchFilter]] = useSearchParam(FILTER_TYPES.SEARCH);
  const [[sortBy]] = useSearchParam(FILTER_TYPES.SORT_BY_MY_PLAYLISTS);
  const [[sortByAll]] = useSearchParam(FILTER_TYPES.SORT_BY);
  return {
    selectedCreatedBy,
    searchFilter,
    sortBy,
    sortByAll
  };
};
export const usePlaylistSaveStatus = playlistId => {
  const {
    playlist,
    playlistLoading
  } = usePlaylist(playlistId);
  const isSaved = playlist && playlist.savedByUser;
  const [savePlaylist] = useSavePlaylist(playlistId);
  const [unsavePlaylist] = useUnsavePlaylist(playlistId);
  const togglePlaylistSaveStatus = () => {
    if (isSaved) return unsavePlaylist();else return savePlaylist();
  };
  return {
    isSaved,
    isLoading: playlistLoading,
    togglePlaylistSaveStatus
  };
};
export const usePlaylistArchivedStatus = playlistId => {
  const {
    playlist,
    playlistLoading
  } = usePlaylist(playlistId);
  const isArchived = playlist && playlist.hiddenForOwner;
  const [toggleHiddenForOwner] = useSetHiddenForOwner(playlistId, !!playlist && !playlist.hiddenForOwner);
  return {
    isArchived,
    isLoading: playlistLoading,
    togglePlaylistArchivedStatus: toggleHiddenForOwner
  };
};